import { ReactElement, useMemo, memo } from 'react';
import { Marker } from 'react-map-gl';

import { toAbsoluteUrl } from '~utils/assetsHelpers';
import { SourceImportType } from '~globals/types/enums';

import { MarkerDeliveryTypeProps } from './types';
import {
  MarkerSourceImportContainer,
  MarkerSourceImportImage,
  MarkerSourceImportArrow,
} from './styles';

const DELIVERIES_TYPES = {
  standard: {
    src: toAbsoluteUrl('/logo_minimal.svg'),
    alt: 'Routix Icon',
  },
  flex: {
    src: toAbsoluteUrl('/images/icon_source_mp@2x.png'),
    alt: 'MercadoPago Icon',
  },
};

const MarkerDeliveryType = ({
  sourceImportTypeId,
  ...restMarkerWrapperProps
}: MarkerDeliveryTypeProps): ReactElement => {
  const currentDeliveryTypeInfo = useMemo(
    () =>
      sourceImportTypeId === SourceImportType.MFlex
        ? DELIVERIES_TYPES.flex
        : DELIVERIES_TYPES.standard,
    [sourceImportTypeId],
  );

  return (
    <Marker {...restMarkerWrapperProps}>
      <MarkerSourceImportContainer>
        <MarkerSourceImportImage {...currentDeliveryTypeInfo} />

        <MarkerSourceImportArrow />
      </MarkerSourceImportContainer>
    </Marker>
  );
};

export default memo(MarkerDeliveryType);
